import { FeatureViewed } from '@ria-client/segment/components/FeatureViewed';
import type { NodeProps } from '../types';
import { TikTokEmbed } from './lib/tiktok-embed';
import { getTikTokVideoId } from './lib/tiktok-url';

export function TikTok({ props }: NodeProps<{ url?: string }>) {
  const { url } = props;
  const videoId = getTikTokVideoId(url);
  if (!url || !videoId) return null;

  return (
    <FeatureViewed
      additionalAttributes={{ url, video_id: videoId }}
      as="div"
      entityName="tiktok"
      entitySection="structured_content"
    >
      <TikTokEmbed key={url} url={url} />
    </FeatureViewed>
  );
}
